import { atom } from 'recoil'
import { Entity } from 'common/types/odino/entity'

export const entityCacheState = atom<{[key: string]: {[key: string]: Entity}}>({
  key: 'entity-cache-state',
  default: {}
})
